<script setup>
import CoPaceEventsModal from "@/views/enterprise/home/content/CoPaceEventsModal.vue";
import {ref} from "vue";

const coPaceEventsModal = ref(null);
</script>

<template>
    <div class="dashboard--client">
        <div class="card card--bordered">
            <header class="dashboard__header">
                <h3 class="heading3">
                    <img src="@/images/co-pace-logo.png" alt="" />
                </h3>
            </header>

            <ul class="list-cards-inrow list-cards-inrow--in3 mb-0">
                <li>
                    <div class="list-cards-inrow__content">
                        <h5 class="heading5">Upcoming Events</h5>

                        <ul class="list-events">
                            <li>
                                <a href="https://tiesv.ai/" target="_blank"><h6 class="heading6">TiECon</h6></a>
                                <time class="list-events__date" datetime="">May 2025</time>
                            </li>
                            <li>
                                <a href="https://www.noah-conference.com/" target="_blank"><h6 class="heading6">NOAH Conf. "Digital, Sustainable, and Profitable”</h6></a>
                                <time class="list-events__date" datetime="">May 3</time>
                            </li>
                            <li>
                                <a href="https://www.deeptech.build/" target="_blank"><h6 class="heading6">DeepTech Momentum</h6></a>
                                <time class="list-events__date" datetime="">May 15</time>
                            </li>
                            <li>
                                <h6 class="heading6">X-BA Call</h6>
                                <time class="list-events__date" datetime="">June 2025</time>
                            </li>
                        </ul>
                        <div class="text-right">
                            <a class="link" @click="coPaceEventsModal.open()">Next Events</a>
                        </div>

                        <CoPaceEventsModal ref="coPaceEventsModal"/>
                    </div>
                </li>
                <li>
                    <div class="list-cards-inrow__content">
                        <h5 class="heading5">News</h5>

                        <figure class="dashboard--client__news">
                            <a href="https://www.continental-automotive.com/en/news/2025/03-31-future-mobility-through-technology-partnerships.html" target="_blank"><img src="@/images/bilo.png" alt=""></a>

                            <figcaption class="dashboard--client__news__figcaption">
                                <a href="https://www.continental-automotive.com/en/news/2025/03-31-future-mobility-through-technology-partnerships.html" target="_blank"><h6 class="heading6">"Shaping the Future of Mobility Through Technology Partnerships"</h6></a>
                                <p>Interview with Jürgen Bilo</p>
                            </figcaption>
                        </figure>
                    </div>
                </li>
                <li>
                    <div class="list-cards-inrow__content">
                        <h5 class="heading5">Reading</h5>

                        <div class="mb-3">
                            <a href="/co-pace/co-pace Collaboration Strategies Slides April 2025.pdf" download>
                                <img src="@/images/co-pace-how.png" alt="">
                            </a>
                        </div>
                        <div>
                            <a href="/co-pace/copace service Blueprint.pdf" download>
                                <img src="@/images/co-pace-blueprint.png" alt="">
                            </a>

                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
